import React from 'react'
import logo from '../images/logo-ipicim.svg';

export class Front extends React.Component {
	render() {
		return (
			<>
				<section className="wrapperFront">
					<div className="frontHome flexCenter">
						<img src={logo} className="ipiLogo" alt="logo" />
					</div>
		      <nav className="fourBtnsIni">
		      	<div className="bigBtnIni">Nursery</div>
		      	<div className="bigBtnIni">Preescolar</div>
		      	<div className="bigBtnIni">Primaria</div>
		      	<div className="bigBtnIni">Secundaria</div>
		      </nav>
		     </section>
			</>
		)
	}
}

export default Front